<template>
  <a-modal
    :title="title"
    :width="1380"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="loading"
    @ok="this.ok"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row>
          <a-col :span="24">
            <a-divider orientation="left">
              关联信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="采销全流程" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="projectFetching ? undefined : null"
                show-search
                v-decorator="[
                  'project_id',
                  {
                    rules: [
                      { required: true, message: '选择' },
                    ],
                  },
                ]"
                placeholder="请输入名称"
                @search="this.projectSearch"
                @change="handleProjectChange"
              >
                <a-spin v-if="projectFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in projectList" :key="d.id">
                  {{ d.name }}（{{ d.number }}）
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="selectedProject">
            <a-form-item label="委托方名称" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              {{ this.selectedProject['host_corporation'] }}
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="selectedProject">
            <a-form-item label="货物名称" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              {{ this.selectedProject['category'] }}
            </a-form-item>
          </a-col>
          <a-col :span="12"></a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              委托报关信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="系统编号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="报告类型" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                option-label-prop="tt"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                show-search
                allow-clear
                v-decorator="[
                  'report_type',
                  {
                    rules: [
                      { required: true, message: '' },
                    ],
                  },
                ]"
                placeholder="请选择"
                :default-active-first-option="false"
              >
                <a-select-option v-for="(item, index) in goodsReportTypeList" :key="index" :tt="item">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              报告数据信息
            </a-divider>
          </a-col>
          <a-col :span="18">
            <a-form-item label="报告内容">
              <a-button icon="plus" @click="handleAddReportData">新建</a-button>
              <a-table
                bordered
                :data-source="otherData.json_data"
                :columns="reportDataColumns"
                v-if="this.otherData.json_data.length > 0"
                :pagination="false"
                key="key">
                <template slot="action" slot-scope="text, record">
                  <a-popconfirm
                    v-if="otherData.json_data.length"
                    title="确定删除?"
                    @confirm="() => onReportDataDelete(record.key)"
                  >
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
              </a-table>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              附件信息
            </a-divider>
          </a-col>
          <a-col :span="18">
            <a-form-item label="合同附件">
              <a-button icon="plus" @click="handleAddAttachment">新建</a-button>
              <a-table
                bordered
                :data-source="otherData.attachment"
                :columns="attachmentColumns"
                v-if="this.otherData.attachment.length > 0"
                :pagination="false"
                key="key">
                <template slot="action" slot-scope="text, record">
                  <a-popconfirm
                    v-if="otherData.attachment.length"
                    title="确定删除?"
                    @confirm="() => onAttachmentDelete(record.key)"
                  >
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
              </a-table>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <attachment-create-form
        ref="attachmentCreateForm"
        @cancel="handleAddCancel"
        @ok="handleOk"
        :record="undefined"
        :visible="visibleFrom"
        v-if="visibleFrom"
        :loading="confirmLoadingFrom"
        :model="undefined" />
      <report-data-form
        ref="reportDataCreateForm"
        @cancel="handleAddReportDataCancel"
        @ok="handleReportDataOk"
        :record="undefined"
        :visible="reportDataVisibleForm"
        v-if="reportDataVisibleForm"
        :loading="confirmLoadingFrom"
        :model="undefined" />
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import debounce from 'lodash/debounce'
import AttachmentCreateForm from '../attachment/modules/CreateForm'
import ReportDataForm from './ReportDataForm'
import { project_list } from '@/api/trade_project'

// 表单字段
const fields = ['id', 'host_corporation_id', 'category_id', 'number', 'name', 'credit', 'cash']
export default {
  components: {
    AttachmentCreateForm,
    ReportDataForm
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    }
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    return {
      projectFetching: false,
      goodsReportTypeList: this.$Dictionaries.trade_goods_report_types,
      clientList: [],
      projectList: [],
      selectedProjectId: undefined,
      selectedProject: undefined,
      form: this.$form.createForm(this),
      otherData: {
        attachment: [],
        json_data: [],
        report_data: undefined
      },
      visibleFrom: false,
      reportDataVisibleForm: false,
      confirmLoadingFrom: false,
      reportDataColumns: [
        {
          title: '名称',
          width: 100,
          dataIndex: 'name'
        },
        {
          title: '内容',
          width: 200,
          dataIndex: 'content'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 50,
          scopedSlots: { customRender: 'action' }
        }
      ],
      attachmentColumns: [
        {
          title: '名称',
          width: '100px',
          dataIndex: 'name'
        },
        {
          title: '附件',
          dataIndex: 'url'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created () {
    console.log('custom modal created', this.form)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    // 当 model 发生改变时，为表单设置值
    this.model && this.form.setFieldsValue(pick(this.model, fields))
  },
  computed: {
    formItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 9 },
          wrapperCol: { span: 15 }
        } : {}
    },
    title () {
      return '新建'
    }
  },
  methods: {
    handleProjectSearch (value) {
      this.projectFetching = true
      this.projectList = []
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = result
      }).finally(() => {
        this.projectFetching = false
      })
    },
    handleProjectChange (value) {
      if (value !== undefined) {
        this.selectedProjectId = value
        this.selectedProject = this.projectList.filter(item => item.id === this.selectedProjectId)[0]
        this.form.setFieldsValue({
          sell_contract_id: undefined
        })
        this.form.setFieldsValue({
          client_ids: undefined
        })
      }
    },
    handleAddReportData () {
      this.reportDataVisibleForm = true
    },
    handleAddAttachment () {
      this.visibleFrom = true
    },
    onReportDataDelete (key) {
      const dataSource = [...this.otherData.json_data]
      this.otherData.json_data = dataSource.filter(item => item.key !== key)
    },
    onAttachmentDelete (key) {
      const dataSource = [...this.otherData.attachment]
      this.otherData.attachment = dataSource.filter(item => item.key !== key)
    },
    handleAddReportDataCancel () {
      this.reportDataVisibleForm = false
      const form = this.$refs.reportDataCreateForm.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleAddCancel () {
      this.visibleFrom = false
      const form = this.$refs.attachmentCreateForm.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleReportDataOk (date) {
      const form = this.$refs.reportDataCreateForm.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values, date)
          // 新增
          const current_date = new Date()
          values.key = current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds()
          this.otherData.json_data.push(values)
          this.reportDataVisibleForm = false
          form.resetFields()
        }
      })
    },
    handleOk (date) {
      const form = this.$refs.attachmentCreateForm.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values, date)
          // 新增
          values.url = values.url.fileList[0].url
          const current_date = new Date()
          values.key = current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds()
          this.otherData.attachment.push(values)
          this.visibleFrom = false
          form.resetFields()
        }
      })
    },
    ok () {
      if (this.otherData.attachment) {
        this.otherData.attachment = this.otherData.attachment.map(item => {
          item.key = undefined
          return item
        })
      }
      if (this.otherData.json_data) {
        this.otherData.report_data = this.otherData.json_data.map(item => {
          item.key = undefined
          return item
        }).reduce((acc, item) => {
          acc[item['name']] = item['content']
          return acc
        }, {})
      }
      // console.log('======', this.otherData)
      this.$emit('ok', this.otherData)
    }
  }
}
</script>
